import React, { useEffect } from "react";
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";
import {
  Bar,
  XAxis,
  YAxis,
  ReferenceLine,
  Tooltip,
  Legend,
  LabelList,
  Line,
  ResponsiveContainer,
  ComposedChart,
  Label,
  Customized
} from "recharts";

export default function EbtidaChart({ ebitdaData }) {
  const [chartAndTableData, setChartAndTableData] = React.useState([]);
  const { getLegendPosition, windowWidth } = ResponsiveLegend();

  useEffect(() => {
    if (ebitdaData && ebitdaData.length > 0) {
      let mappedData = ebitdaData.map((data) => ({
        name: formateMonthName(data.mesAno),
        ebitdaPdv: data.ebitdaPdv,
        percentualEbitda: data.percentualEbitda,
        capilaridade: data.capilaridade,
        totalEbitda: data.totalEbitda
      }));
      setChartAndTableData(mappedData);
    }
  }, [ebitdaData]);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      let data = payload[0].payload;
      let barData = `R$ ${data.ebitdaPdv.toLocaleString('pt-BR').split(',')[0]}`;
      let lineData = `${new Intl.NumberFormat('pt').format(data.percentualEbitda)}%`
      return (
        <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
          <p>{data.name}</p>
          <p>POR PDV: {barData}</p>
          <p>%: {lineData}</p>
        </div>
      );
    }
    return null;
  };

  const renderCustomLabelLine = (props) => {
    const { x, y, value } = props;

    let dy = 0;
    if (value > 0) {
      dy = -10; // Define um deslocamento para cima se o valor for maior que zero
    } else {
      dy = 25; // Define um deslocamento para baixo se o valor for menor ou igual a zero
    }

    return (
      <text x={x} y={y} dy={dy} fill="#000" textAnchor="middle">
        {`${value}%`}
      </text>
    );
  };

  return (
    <div>
      <ResponsiveContainer width='99%' height={400}>
        <ComposedChart
          width={1200}
          height={400}
          data={chartAndTableData}
          margin={{
            top: 20,
            right: 30,
            left: 5,
            bottom: 10
          }}
        >
          <XAxis dataKey="name" stroke="#000" axisLine={false} tickLine={false} tickMargin={20} style={{ fontWeight: 'bold', marginTop:'20px' }} />
          <YAxis hide />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            align={windowWidth > 600 ? 'left' : 'center'}
            layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
            iconSize={10}
            wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(), minWidth: '140px', width: '140px',maxWidth: '140px'} : { ...getLegendPosition() }}
            formatter={(value, entry) => <span style={{ color: '#000', fontSize: '10px' }}>{value}</span>}
          />
          <Bar
            dataKey="ebitdaPdv"
            name="POR PDV"
            fill="#CCC"
            legendType="square"
          >
            <LabelList
              dataKey="ebitdaPdv"
              fill="#666"
              formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
            />
          </Bar>
          <Line
            type="monotone"
            dataKey="ebitdaPdv"
            data={chartAndTableData}
            name="%"
            stroke="#000"
            legendType="plainline"
            dot={false}
          >
            <LabelList dataKey="percentualEbitda" content={renderCustomLabelLine} />
          </Line>
          <ReferenceLine y={0} stroke="#666" />
        </ComposedChart>
      </ResponsiveContainer>
      <div style={{ marginRight: '40px' }}>
        <table
          style={{
            width: '100%',
            borderTop: '1px solid #000',
            borderBottom: '1px solid #000',
            tableLayout: 'fixed'
          }}
        >
          <tbody>
            <tr>
              <th style={{ minWidth: '137px', width: '137px'}}>CAPILARIDADE</th>
              {chartAndTableData.map((item, index) => (
                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                  {new Intl.NumberFormat('pt').format(item.capilaridade)}
                </td>
              ))}
            </tr>
            <tr style={{ border: '1px dotted #000' }}></tr>
            <tr>
              <th style={{ minWidth: '137px', width: '137px'}}>TOTAL</th>
              {chartAndTableData.map((item, index) => (
                <td key={index} style={{ color: item.totalEbitda < 0 ? '#FF0000' : '#000', textAlign: 'center', fontSize: '10px' }}>
                  {item.totalEbitda.toLocaleString('pt-BR').split(',')[0]}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

